import React from "react"
import { APIpath, fetchBannerBlog, fetchActiveBlogs } from '../actions'
import { getPost, getPosts, getBanners } from '../reducers'
import { connect } from 'react-redux'
import { Image, Text, Flex, Box, Button, Heading, Tag } from '@chakra-ui/react'
import Layout from '../layout'
import call from '../multimedia/imagenes/call2.jpeg'
import HeroCarousel from "../components/HeroCarousel"
import { Link } from "react-router-dom"
import { isEmpty } from "../utils"

class BlogPost extends React.Component {


    componentDidMount() {
        this.props.fetchActiveBlogs()
        this.props.fetchBannerBlog()
    }

    render() {

        const { activePost, posts, banners } = this.props

        let i = 0


        if (isEmpty(activePost)) {
            return (<Layout > Cargando... </Layout>)
        } else {
            let activeTags = activePost.tag !== '' ? activePost.tag.split(",") : []

            let fecha = new Date(activePost.updated_at)

            return (
                <Layout >
                    <Flex flexDir={{ base: 'column', md: 'row' }} bg={"easycar1.500"} w={"100%"} p={5} textAlign={"center"} marginTop={"20px"} marginBottom={"20px"} alignItems={"center"} display={"flex"} justifyContent={"space-evenly"}>
                        <Text as={"b"} fontSize={"4xl"} color={"white"}>Estrena tu próximo vehículo mediante pagos mensuales en 24 horas</Text> <a
                            href={`https://wa.me/+50372900087?text=Hola%2C+me+gustaria+precalificar+para+adquirir+un+veh%C3%ADculo+de+su+sitio+web+en+pagos+mensuales.&type=phone_number&app_absent=0`}
                            target={"_blank"}
                            rel="noreferrer">
                            <Button colorScheme={"green"} variant={"outline"}>
                                Chatea con un ejecutivo/a
                            </Button>
                        </a>
                    </Flex>

                    <Box maxW={"1400px"} p={{ base: 4, md: 6 }} m={"auto"} mt={"20px"} mb={"20px"}>

                        <Box mb={8}>

                            <Link to="/blog" onClick={() => window.scrollTo(0, 0)} style={{ textDecoration: 'none' }}>
                                <Button

                                    leftIcon={<span aria-hidden="true">←</span>}
                                    size="sm"
                                    fontWeight="bold"
                                    colorScheme="green"
                                    variant="outline"
                                    bg="white"
                                    borderColor="gray.200"
                                    rounded="xl"
                                    boxShadow="sm"
                                    _hover={{ bg: "green.50" }}
                                >
                                    Volver al blog
                                </Button>
                            </Link>
                        </Box>

                        <Flex flexDir={{ base: "column", lg: "row" }} align="start" gap={10}>
                            <Box flex={2} minW={0} w="full" bg="white" color="gray.700" rounded="3xl" p={{ base: 6, sm: 10 }} border="1px solid" borderColor="gray.200" boxShadow="sm">

                                {activeTags.map((tag, index) => (
                                    <Tag key={`${tag}-${index}`} colorScheme="green" rounded="full" px={3.5} py={1.5} textTransform="uppercase" fontSize="xs" fontWeight="extrabold">
                                        {tag}
                                    </Tag>
                                ))}

                                <Heading as="h1" size={{ base: "xl", sm: "2xl" }} color="gray.900" mt={4} mb={4} lineHeight="tight">
                                    {activePost.title}
                                </Heading>
                                <Flex align="center" gap={3} mb={8} pb={4} borderBottom="1px solid" borderColor="gray.100" color="gray.400" fontSize="xs" fontWeight="semibold" flexWrap="wrap">
                                    <Text>Publicado: {fecha.toLocaleDateString()}</Text>
                                </Flex>

                                <Image alt={activePost.title} height={{ base: "18rem", sm: "24rem" }} width="full" src={`${APIpath}/blog/image/${activePost.id}`} objectFit="cover" rounded="2xl" mb={8} border="1px solid" borderColor="gray.200" />

                                <Box className="blogContent" fontSize={{ base: "md", sm: "lg" }} lineHeight="relaxed" color="gray.700" sx={{ "p": { mb: 6 }, "img": { maxW: "100%", h: "auto", rounded: "lg" } }} dangerouslySetInnerHTML={{ __html: activePost.content }} />

                                <Flex flexDir={{ base: "column", sm: "row" }} align="center" justify="space-between" gap={6} mt={12} p={8} bgGradient="linear(to-br, gray.900, gray.800)" color="white" rounded="3xl" boxShadow="xl">
                                    <Box textAlign={{ base: "center", sm: "left" }}>
                                        <Tag bg="green.500" bgOpacity={0.2} rounded="full" px={3} py={1} textTransform="uppercase" fontSize="xs" fontWeight="extrabold">Financiamiento flexible</Tag>
                                        <Heading as="h3" size="md" mt={2}>Paga tu vehículo mensualmente con nuestro arrendamiento financiero</Heading>
                                        <Text fontSize="xs" color="gray.400" mt={2}>Conoce todos los requisitos para aplicar hoy mismo sin afectar tu capital.</Text>
                                    </Box>
                                    <Link to="/requisitos" onClick={() => window.scrollTo(0, 0)}>
                                        <Button colorScheme="green" rounded="2xl" whiteSpace="nowrap">¡Páguelo mensualmente!</Button>
                                    </Link>
                                </Flex>
                            </Box>

                            <Box flex={1} minW={0} w="full" bg="white" rounded="3xl" p={6} border="1px solid" borderColor="gray.200" boxShadow="sm">
                                <Heading as="h3" size="md" color="gray.900" borderBottom="1px solid" borderColor="gray.100" pb={3} mb={4}>
                                    Artículos recomendados
                                </Heading>
                                <Flex direction="column" gap={4}>
                                    {posts.filter(postSimilar => {
                                        if (postSimilar.id === activePost.id) return false
                                        if (activeTags.length > 0) {
                                            return activeTags.some(tag => postSimilar.tag && postSimilar.tag.split(",").includes(tag))
                                        }
                                        return true
                                    }).map(post => {
                                        if (i < 4) {
                                            i++
                                            return <Box key={post.id}>
                                                <Link to={`/blog/${post.id}?${Math.random().toString(36)}`}>
                                                    <Flex gap={4} align="center">
                                                        <Image alt={post.title} boxSize="20" flexShrink={0} src={`${APIpath}/blog/image/${post.id}`} objectFit="cover" rounded="xl" />
                                                        <Box>
                                                            <Text noOfLines={2} fontWeight="bold" color="gray.900">{post.title}</Text>
                                                            <Text noOfLines={2} mt={1} fontSize="sm" color="gray.500">{post.description}</Text>
                                                        </Box>
                                                    </Flex>
                                                </Link>
                                            </Box>
                                        }
                                        return undefined
                                    })}
                                </Flex>
                            </Box>
                        </Flex>
                    </Box>

                    <HeroCarousel banners={banners} />

                    <Flex flexDir={{ base: 'column', md: 'row' }} bg={"easycar1.500"} w={"100%"} p={5} textAlign={"center"} marginTop={"20px"} marginBottom={"20px"} alignItems={"center"} display={"flex"} justifyContent={"space-evenly"}>
                        <Text as={"b"} fontSize={"4xl"} color={"white"}>Estrena tu próximo vehículo mediante pagos mensuales en 24 horas</Text> <a
                            href={`https://wa.me/+50372900087?text=Hola%2C+me+gustaria+precalificar+para+adquirir+un+veh%C3%ADculo+de+su+sitio+web+en+pagos+mensuales.&type=phone_number&app_absent=0`}
                            target={"_blank"}
                            rel="noreferrer">
                            <Button colorScheme={"green"} variant={"outline"}>
                                Chatea con un ejecutivo/a
                            </Button>
                        </a>
                    </Flex>

                    <Box w={"full"} mt={"4rem"}>
                        <Flex maxW={"1400px"} flexDir={{ base: 'column', md: 'row' }} p={4} m={"auto"}>
                            <Box flex={1} p={"10"} margin={"auto"} >
                                <Heading>Aprobamos tu plan de pago con la mejor asesoría</Heading>
                                <br />
                                <Text>Contamos con ejecutivos/as personalizados que te acompañaran en todo el proceso</Text>
                                <br />
                                <Link to={"/requisitos"} onClick={() => window.scrollTo(0, 0)}>
                                    <Button colorScheme="easycar2">Compra tu vehículo en cuotas</Button>
                                </Link>
                            </Box>
                            <Box flex={1} alignItems={"center"} justifyContent={"center"} margin={"auto"}>
                                <Image alt={'Call Center'} height={"500px"} width={"auto"} src={call} margin={"auto"} />
                            </Box>
                        </Flex>
                    </Box>
                </Layout>
            )

        }

    }

}

const mapStateToProps = (state, ownProps) => ({
    activePost: getPost(state, ownProps.match.params.id),
    posts: getPosts(state),
    banners: getBanners(state)
})

const mapDispatchToProps = { fetchBannerBlog, fetchActiveBlogs }

export default connect(mapStateToProps, mapDispatchToProps)(BlogPost)